module.exports = __webpack_public_path__ + "img/pic_left.55622be0.svg";